export enum SiteListItemId {
  CreateSite = 'createAndDeleteSite',
  EditSite = 'editSite',
  DeleteSite = '003',
  EdgeNetwork = 'edgeNetwork',
  EdgeControl = 'edgeControl',
  AssociateToSelf = 'showSiteNotRelated',
  RelatedAffiliate = 'relatedAffiliate',
}
